import { motion } from "framer-motion";
import { CONTACT } from "@/data/content";
import { assetUrl } from "@/lib/assets";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } },
};

export const ContactFooter = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      id="contact"
      data-testid="contact-section"
      className="bg-forestdeep text-white px-6 md:px-12 pt-24 md:pt-36 pb-10"
    >
      <div className="mx-auto max-w-[1400px]">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
        >
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-lime">
            (04) — Let&apos;s talk
          </span>
          <h2 className="mt-5 font-display font-extrabold tracking-tighter leading-[0.9] text-6xl sm:text-7xl md:text-[9vw]">
            Let&apos;s grow
            <br />
            <span className="text-lime">organically.</span>
          </h2>
        </motion.div>

        <div className="mt-14 flex flex-col sm:flex-row gap-4">
          <a
            href={CONTACT.calendly}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-cta-book"
            className="group inline-flex items-center justify-between gap-6 rounded-full bg-lime px-8 py-5 text-lg font-semibold text-forestdeep hover:bg-white transition-colors duration-300"
          >
            Book a strategy call
            <span className="inline-block transition-transform duration-300 group-hover:translate-x-1.5">→</span>
          </a>
          <a
            href={CONTACT.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-cta-whatsapp"
            className="inline-flex items-center justify-center gap-3 rounded-full border border-white/25 px-8 py-5 text-lg font-semibold text-white hover:bg-white hover:text-forestdeep transition-colors duration-300"
          >
            WhatsApp us
          </a>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-white/10 pt-12">
          <div>
            <div className="font-mono text-xs uppercase tracking-[0.2em] text-white/40 mb-3">
              Email
            </div>
            <a
              href={`mailto:${CONTACT.email}`}
              data-testid="footer-email"
              className="text-xl font-medium text-white link-underline pb-1 hover:text-lime transition-colors duration-300 break-all"
            >
              {CONTACT.email}
            </a>
          </div>
          <div>
            <div className="font-mono text-xs uppercase tracking-[0.2em] text-white/40 mb-3">
              Phone
            </div>
            <a
              href={`tel:${CONTACT.phoneRaw}`}
              data-testid="footer-phone"
              className="text-xl font-medium text-white link-underline pb-1 hover:text-lime transition-colors duration-300"
            >
              {CONTACT.phone}
            </a>
          </div>
          <div>
            <div className="font-mono text-xs uppercase tracking-[0.2em] text-white/40 mb-3">
              Studio
            </div>
            <p className="text-lg font-medium text-white/80 leading-relaxed">
              {CONTACT.address}
            </p>
          </div>
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-white/10 pt-8">
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center rounded-md bg-white px-3 py-2">
              <img src={assetUrl("logo.png")} alt="ItsOrganic" className="h-6 w-auto" />
            </span>
          </div>
          <p className="font-mono text-xs uppercase tracking-[0.15em] text-white/40">
            © {year} ItsOrganic · A SocialPotato brand · All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
};
